import {useContext} from 'react';

import {ThemeContext} from '../../pages/_app';

export const useTheme = () => {
  const {isDarkMode} = useContext(ThemeContext);

  return {
    isDarkMode,
  };
};
